import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMessageQuestionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill="#212121"
      d="M7 0a7 7 0 1 1-3.211 13.22l-2.678.747A.875.875 0 0 1 .033 12.89l.747-2.675A7 7 0 0 1 7 0m0 1.05a5.95 5.95 0 0 0-5.199 8.845l.106.19-.78 2.788 2.791-.779.189.106A5.95 5.95 0 1 0 7 1.05m0 8.4a.7.7 0 1 1 0 1.4.7.7 0 0 1 0-1.4m0-6.125c1.063 0 1.925.861 1.925 1.925 0 .707-.208 1.101-.736 1.65l-.118.12c-.435.436-.546.62-.546 1.03a.525.525 0 0 1-1.05 0c0-.708.208-1.102.736-1.652l.118-.12c.435-.435.546-.62.546-1.028a.875.875 0 0 0-1.745-.09l-.005.09a.525.525 0 0 1-1.05 0c0-1.064.862-1.925 1.925-1.925"
    />
  </svg>
);
export default SvgMessageQuestionIcon;
